// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/machines",
  Short: "/pyr/machines/short",
  Detail: "/pyr/machines",
  Create: "/pyr/machines",
  Update: "/pyr/machines",
  Delete: "/pyr/machines",
};
